"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _designSystem = require("@superlogica/design-system");

var _Table = _interopRequireDefault(require("./Table"));

var ErrorTable = function ErrorTable(_ref) {
  var footer = _ref.footer,
      hiddenColumns = _ref.hiddenColumns,
      tableName = _ref.tableName,
      retry = _ref.retry;
  var loadingData = [{}];
  var errorColumns = [{
    Header: 'Não foi possível carregar os dados da tabela',
    accessor: 'error',
    Cell: function Cell() {
      return /*#__PURE__*/_react.default.createElement(_designSystem.Button, {
        onClick: retry
      }, "Recarregar");
    }
  }];
  return /*#__PURE__*/_react.default.createElement(_Table.default, {
    columns: errorColumns,
    footer: footer,
    data: loadingData,
    tableName: tableName,
    hiddenColumns: hiddenColumns
  });
};

var _default = ErrorTable;
exports.default = _default;